import { Col, CustomIcon, Paragraph, Row, Spin } from 'antd/index';
import React, { useState } from 'react';
import { func, array, number, string, bool, oneOfType } from 'prop-types';
import { setContestDescription } from './ManageTestSlice';
import { useDispatch } from 'react-redux';
import CustomTableContainer from 'components/CustomTable/CustomTableContainer';
import QuestionDetailsModal from '../../components/QuestionDetailsModal/QuestionDetailsModal';
import addNewTestTableShape from 'views/TableShapes/addNewTestTableShape';
import QuestionsPanelContainer from './QuestionPanelContainer';
import FailureMessageModal from '../../components/FailureMessageModal/AddNewFailure';
import { MANAGE_TEST_VIEW } from '../../constants';
import MDEditor, { commands } from '@uiw/react-md-editor';

const {
  EDIT_FAILED,
  CONTACT_ADMINISTRATOR,
  CLOSE,
  OOPS,
  PLEASE_SET_CRITERIA,
  CONTEST_DESCRIPTION,
  TEXTAREA_PLACEHOLDER,
} = MANAGE_TEST_VIEW;

const MyIcon = () => {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.373829 5.8418C-0.0687829 6.73656 -0.0687827 7.79085 0.373829 8.68562C1.9386 11.8489 5.21319 14.026 8.9994 14.026C12.7856 14.026 16.0602 11.8489 17.625 8.68562C18.0676 7.79086 18.0676 6.73657 17.625 5.8418C16.0602 2.67852 12.7856 0.501465 8.9994 0.501465C5.21319 0.501465 1.9386 2.67852 0.373829 5.8418ZM1.96949 6.23931C1.61921 6.87655 1.61921 7.65008 1.96949 8.28732C3.32772 10.7583 5.96653 12.4344 8.99924 12.4344C12.032 12.4344 14.6708 10.7583 16.029 8.28733C16.3793 7.65009 16.3793 6.87655 16.029 6.23931C14.6708 3.76833 12.032 2.09221 8.99924 2.09221C5.96653 2.09221 3.32772 3.76832 1.96949 6.23931Z"
        fill="#A5A5A5"
      />
      <ellipse cx="9.01291" cy="7.26424" rx="2.80172" ry="2.7845" fill="#A5A5A5" />
    </svg>
  );
};

const EditIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.06975 11.3798L14.3751 6.08331C14.7753 5.68213 15 5.1386 15 4.57193C15 4.00526 14.7753 3.46173 14.3751 3.06055L12.9841 1.62496C12.5829 1.22475 12.0394 1 11.4727 1C10.9061 1 10.3626 1.22475 9.9614 1.62496L1.72258 9.8194C1.4886 10.0529 1.30406 10.3312 1.17997 10.6376C1.05588 10.944 0.994792 11.2722 1.00035 11.6027V13.6625C1.00035 14.0172 1.14126 14.3574 1.39208 14.6083C1.64291 14.8591 1.9831 15 2.33782 15H4.56694C4.84566 14.9993 5.12135 14.9421 5.3773 14.8317C5.63325 14.7213 5.86414 14.5602 6.05599 14.358V14.358C6.16298 14.2599 6.57314 13.8319 6.61772 13.7784C6.7926 13.6014 6.89718 13.3669 6.91197 13.1186C6.91703 12.9365 6.86623 12.7573 6.76638 12.6049C6.66653 12.4526 6.52242 12.3345 6.35345 12.2665C6.18448 12.1986 5.99875 12.184 5.82123 12.2247C5.64371 12.2654 5.48293 12.3596 5.3605 12.4944V12.4944L5.10192 12.753C4.80653 13.0491 4.40565 13.2159 3.98737 13.2167H2.91739C2.88192 13.2167 2.8479 13.2026 2.82282 13.1775C2.79773 13.1524 2.78364 13.1184 2.78364 13.0829V11.9505C2.78484 11.5699 2.93531 11.2049 3.20272 10.934L8.97167 5.19164C9.04516 5.11867 9.14452 5.07773 9.24808 5.07773C9.35164 5.07773 9.451 5.11867 9.52449 5.19164L10.8085 6.47564C10.8814 6.54914 10.9224 6.6485 10.9224 6.75206C10.9224 6.85562 10.8814 6.95498 10.8085 7.02848L7.76795 10.0869C7.5965 10.2595 7.50065 10.4932 7.50149 10.7365C7.50232 10.9798 7.59978 11.2128 7.77241 11.3843C7.94504 11.5557 8.1787 11.6516 8.422 11.6507C8.6653 11.6499 8.89831 11.5525 9.06975 11.3798V11.3798ZM10.7461 3.87197C10.6859 3.80622 10.6525 3.72033 10.6525 3.63122C10.6525 3.5421 10.6859 3.45622 10.7461 3.39047L11.2365 2.90005C11.3022 2.8399 11.3881 2.80654 11.4772 2.80654C11.5663 2.80654 11.6522 2.8399 11.7179 2.90005L13.1 4.29997C13.1601 4.36572 13.1935 4.45161 13.1935 4.54072C13.1935 4.62983 13.1601 4.71572 13.1 4.78147L12.5918 5.25406C12.526 5.31421 12.4401 5.34757 12.351 5.34757C12.2619 5.34757 12.176 5.31421 12.1103 5.25406L10.7461 3.87197Z"
        fill="#A5A5A5"
      />
      <path
        d="M14.1026 13H8.89744C8.65942 13 8.43115 13.1054 8.26285 13.2929C8.09455 13.4804 8 13.7348 8 14C8 14.2652 8.09455 14.5196 8.26285 14.7071C8.43115 14.8946 8.65942 15 8.89744 15H14.1026C14.3406 15 14.5688 14.8946 14.7371 14.7071C14.9054 14.5196 15 14.2652 15 14C15 13.7348 14.9054 13.4804 14.7371 13.2929C14.5688 13.1054 14.3406 13 14.1026 13Z"
        fill="#A5A5A5"
      />
    </svg>
  );
};

const customCommands = [commands.bold, commands.italic, commands.quote];
const customEditCommand = { ...commands.codeEdit, icon: <CustomIcon component={EditIcon} /> };
const customPreviewCommand = { ...commands.codePreview, icon: <CustomIcon component={MyIcon} /> };
const customExtraCommands = [customEditCommand, customPreviewCommand];

// COMMENTED THIS OUT CUZ OF THE BUG WITH RENDERING ICON, THE SOLUTION BELOW IS TEMPORARY AND NOT OPTIMAL AT ALL...
// import { ReactComponent as LackQuestionsIcon } from '../../assets/icons/lack-questions-icon.svg'
// COMMENTED THIS OUT CUZ OF THE BUG WITH RENDERING ICON, THE SOLUTION BELOW IS TEMPORARY AND NOT OPTIMAL AT ALL...
const LackQuestionIcon = () => {
  return (
    <svg
      className="lack-question"
      width="320"
      height="320"
      viewBox="0 0 320 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="320" height="320" rx="40" fill="#2D2D2D" />
      <g filter="url(#filter0_d_4435:42102)">
        <rect x="112" y="56" width="80" height="110" rx="8" fill="#4C4C4C" />
      </g>
      <rect x="122" y="69" width="60" height="3" rx="1.5" fill="#8F8F8F" />
      <rect x="122" y="113" width="60" height="3" rx="1.5" fill="#8F8F8F" />
      <rect x="122" y="102" width="60" height="3" rx="1.5" fill="#8F8F8F" />
      <rect x="122" y="80" width="24" height="3" rx="1.5" fill="#8F8F8F" />
      <rect x="122" y="124" width="24" height="3" rx="1.5" fill="#8F8F8F" />
      <rect x="122" y="152" width="36" height="3" rx="1.5" fill="#8F8F8F" />
      <g filter="url(#filter1_b_4435:42102)">
        <circle cx="183" cy="113" r="23" fill="#3D6FF8" fillOpacity="0.5" />
      </g>
      <g filter="url(#filter2_dii_4435:42102)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M207.566 131.91C211.601 126.677 214 120.119 214 113C214 95.8792 200.121 82 183 82C165.879 82 152 95.8792 152 113C152 130.121 165.879 144 183 144C190.118 144 196.676 141.601 201.91 137.567L211.59 147.247C213.152 148.809 215.684 148.809 217.246 147.247C218.808 145.685 218.808 143.152 217.246 141.59L207.566 131.91ZM206 113C206 125.703 195.703 136 183 136C170.297 136 160 125.703 160 113C160 100.297 170.297 90 183 90C195.703 90 206 100.297 206 113Z"
          fill="url(#paint0_linear_4435:42102)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4435:42102"
          x="110"
          y="56"
          width="84"
          height="114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4435:42102" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4435:42102" result="shape" />
        </filter>
        <filter
          id="filter1_b_4435:42102"
          x="154"
          y="84"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="3" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4435:42102" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_4435:42102" result="shape" />
        </filter>
        <filter
          id="filter2_dii_4435:42102"
          x="144"
          y="78"
          width="82.418"
          height="82.4185"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4435:42102" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4435:42102" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_4435:42102" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect2_innerShadow_4435:42102" result="effect3_innerShadow_4435:42102" />
        </filter>
        <linearGradient id="paint0_linear_4435:42102" x1="183" y1="82" x2="183" y2="144" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A29F9F" />
          <stop offset="1" stopColor="#7D7D7D" />
        </linearGradient>
      </defs>
      <text x="75" y="220" fill="rgba(255, 255, 255, 0.85)">
        {OOPS}
      </text>
      <text x="50" y="250" fill="#616161">
        {PLEASE_SET_CRITERIA}
      </text>
    </svg>
  );
};

const ManageTestUI = ({
  levelFilterOption,
  levelFilter,
  handleOnClickAddNew,
  setNumberOfItemsQuestionsPage,
  numberOfItemsQuestionsPage,
  handleOnAdd,
  role,
  onlevelFilterChange,
  onCategoryOptionsChange,
  setSearchFilter,
  filterTable,
  isQuestionsReadyToRender,
  currentPage,
  setCurrentPage,
  handleClearFilters,
  categoryOptions,
  searchFilter,
  selectedQuestions,
  handleRemoveQuestionFromList,
  handleCloseErrorModal,
  hasFailedShowModal,
  contestDescription,
}) => {
  const dispatch = useDispatch();
  const showModal = (isModal, dataQuestion) => {
    setIsModalVisible(isModal);
    setDataQuestionModal(dataQuestion);
  };
  const columnsHandlers = {
    handleOnAdd,
    role,
    showModal,
  };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataQuestionModal, setDataQuestionModal] = useState({});
  const componentName = 'manageTest';

  const handleCancel = () => {
    setIsModalVisible(false);
    setDataQuestionModal({});
  };
  const pagination = {
    defaultPageSize: numberOfItemsQuestionsPage,
    pageSizeOptions: [7, 14, 21],
    position: ['bottomCenter'],
    defaultCurrent: currentPage,
    onChange: current => setCurrentPage(current),
    showSizeChanger: true,
    locale: { items_per_page: '/ page' },
    onShowSizeChange: (_, size) => setNumberOfItemsQuestionsPage(size),
  };

  const onChangeTextArea = value => {
    dispatch(setContestDescription(value));
  };

  return (
    <Row className="manage-test-row">
      <QuestionDetailsModal
        dataQuestionModal={dataQuestionModal}
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        setIsModalVisible={setIsModalVisible}
      />
      <Col className="manage-test-col">
        <FailureMessageModal
          firstLine={EDIT_FAILED}
          secondLine={CONTACT_ADMINISTRATOR}
          buttonTextAccept={CLOSE}
          handleOnClickAccept={handleCloseErrorModal}
          isVisible={hasFailedShowModal}
        />
        {isQuestionsReadyToRender ? (
          <>
            <Row justify="start" align="middle" className="container-row">
              <Col className="manage-test-table-container">
                <CustomTableContainer
                  classNameTable={'table'}
                  tableClass={'question--panel'}
                  columnsHandlers={columnsHandlers}
                  setSearchFilter={setSearchFilter}
                  numberOfItemsQuestionsPage={numberOfItemsQuestionsPage}
                  currentPage={currentPage}
                  handleClearFilters={handleClearFilters}
                  handleOnClickAddNew={handleOnClickAddNew}
                  onlevelFilterChange={onlevelFilterChange}
                  categoryOptions={categoryOptions}
                  levelFilter={levelFilter}
                  levelFilterOption={levelFilterOption}
                  setCurrentPage={setCurrentPage}
                  onCategoryOptionsChange={onCategoryOptionsChange}
                  searchFilter={searchFilter}
                  setNumberOfItemsQuestionsPage={setNumberOfItemsQuestionsPage}
                  dataToRender={filterTable}
                  componentName={componentName}
                  tableShape={addNewTestTableShape}
                  pagination={pagination}
                  locale={{ emptyText: <CustomIcon component={LackQuestionIcon} /> }}
                />
              </Col>
            </Row>
            <Row className="description-section">
              <Paragraph className="description-section__title">{CONTEST_DESCRIPTION}</Paragraph>
              <MDEditor
                value={contestDescription}
                onChange={onChangeTextArea}
                className="contest-description"
                preview="edit"
                commands={customCommands}
                extraCommands={customExtraCommands}
                textareaProps={{
                  maxLength: 10000,
                  placeholder: TEXTAREA_PLACEHOLDER,
                }}
              />
            </Row>
          </>
        ) : (
          <Row justify="start" align="middle" className="spinner-container">
            <Spin size="large" />
          </Row>
        )}
      </Col>
      <QuestionsPanelContainer
        selectedQuestions={selectedQuestions}
        showModal={showModal}
        handleRemoveQuestionFromList={handleRemoveQuestionFromList}
      />
    </Row>
  );
};

ManageTestUI.propTypes = {
  resetFilter: func,
  filterTable: array,
  setNumberOfItemsQuestionsPage: func,
  numberOfItemsQuestionsPage: number,
  role: string,
  onlevelFilterChange: func,
  levelFilterOption: oneOfType([string, array]),
  setSearchFilter: func,
  sortArray: func,
  handleOnClickAddNew: func,
  handleOnAdd: func,
  levelFilter: oneOfType([string, array]),
  setFilteredQuestions: func,
  filteredQuestions: array,
  questionsToRender: array,
  onCategoryOptionsChange: func,
  isQuestionsReadyToRender: bool,
  currentPage: number,
  setCurrentPage: func,
  subjects: array,
  areResultsFiltered: bool,
  handleClearFilters: func,
  selectedQuestionsState: array,
  categoryOptions: array,
  searchFilter: string,
  selectedQuestions: array,
  handleRemoveQuestionFromList: func,
  handleCloseErrorModal: func,
  hasFailedShowModal: bool,
  contestDescription: string,
};

export default ManageTestUI;
